import React from 'react';
import withIcon from '../utilities/withIcon'; 

const IconUnnest = () => {
  return (
    <g>
      <path
        d="m10.05 9 4.903.015c.54.001.984.41 1.04.935l.007.115v4.885c0 .541-.41.987-.936 1.044L14.95 16h-4.9a1.05 1.05 0 0 1-1.044-.936L9 14.95v-4.9c0-.54.41-.986.936-1.043l.114-.006zm-6.18.471a.759.759 0 0 1 0 1.07l-1.197 1.203h4.575c.415 0 .752.339.752.756 0 .38-.278.694-.64.748l-.112.008H2.673l1.196 1.204a.759.759 0 0 1 0 1.069.75.75 0 0 1-1.063 0l-2.66-2.673a.506.506 0 0 1-.057-.643l.058-.07 2.659-2.672a.75.75 0 0 1 1.063 0zm6.63 1.03V14.5h4v-3.987l-4-.012zM1.05.001l13.901.014c.54 0 .986.41 1.043.936l.006.114V5.95c0 .541-.41.987-.936 1.044L14.95 7H1.05a1.05 1.05 0 0 1-1.044-.936L0 5.95v-4.9C0 .51.41.063.936.006L1.051 0zM1.5 1.5v4h13V1.515L1.5 1.5z"
        
      />
    </g>
  );
};

export default withIcon(IconUnnest);
